import { logger } from '@adornis/base/logging.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-button.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import { XDialog } from '@adornis/dialog/x-dialog.js';
import { permissionGuard } from '@ils/permissions/client/permissionGuard.js';
import { html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { state } from 'lit/decorators/state.js';
import { ExamDay } from '../../db/examdays.js';
import { currentExamDay } from '../global-state.js';

@customElement('ils-extend-exam')
export class ILSExtendExam extends XDialog<boolean> {
  static override get element_name() {
    return 'ils-extend-exam';
  }
  @state() private readonly selectedExamDay = new RXController(this, currentExamDay);

  override render() {
    if (!this.selectedExamDay.value) return nothing;
    return html`
      <x-flex padding="lg" space="lg" ${css({ minWidth: '400px', minHeight: '300px' })}>
        <x-h1> Prüfung verlängern </x-h1>
        <x-flex horizontal center crossaxis-center space="md">
          ${permissionGuard({
            resource: 'slots',
            action: 'extend',
            guardedTemplate: html`
              <x-button @click=${async () => this.extendExam(1)}> 1 min </x-button>
              <x-button @click=${async () => this.extendExam(2)}> 2 min </x-button>
              <x-button @click=${async () => this.extendExam(5)}> 5 min </x-button>
              <x-button @click=${async () => this.extendExam(10)}> 10 min </x-button>
            `,
            forbiddenTemplate: html` <x-text> Keine Erlaubnis die Prüfung zu verlängern </x-text> `,
          })}
        </x-flex>
        <x-button
          tone="error"
          mode="outline"
          end
          ${css({ alignSelf: 'end', marginTop: 'auto' })}
          @click=${() => this.close(false)}
        >
          Abbrechen
        </x-button>
      </x-flex>
    `;
  }

  private async extendExam(time: number) {
    try {
      const confirm = await XDialog.confirm(`Wollen Sie wirklich die Prüfung um ${time} min. verlängern?`);

      if (confirm) {
        await XDialog.waitFor(
          ExamDay.extendCurrentSlots(this.selectedExamDay.value!._id, time)(),
          'Slots werden angepasst..',
        );

        void this.close(true);
      } else void this.close(false);
    } catch (e) {
      logger.error(e);
      this.reject('Beim verlängern der Slots ist etwas schief gelaufen.');
    }
  }
}
